import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';

export enum MilestoneStatus {
    Completed = 'completed',
    InProgress = 'in-progress',
    Pending = 'pending'
}

@Component({
    selector: 'app-milestone',
    templateUrl: './milestone.component.html',
    styleUrls: ['./milestone.component.scss']
})
export class MilestoneComponent implements AfterViewInit {
    @Input()
    status: MilestoneStatus = MilestoneStatus.Pending;

    @ViewChild('milestoneNameContainer')
    private milestoneNameContainer: ElementRef;

    milestoneName: string;
    orderNumber: number;
    lastMilestone: boolean;

    ngAfterViewInit(): void {
        this.milestoneName = this.milestoneNameContainer.nativeElement.innerText;
    }

    public getDisplayOrderNumber(): number {
        if (this.status !== MilestoneStatus.Completed) {
            return this.orderNumber;
        }
    }
}
